import { ElementRef, Inject, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EditModeService {

  isEditMode$ = new BehaviorSubject<{status : boolean;loading:boolean }>({status: false, loading:false});

  toggleEditMode = (loading?: boolean) => {
    this.isEditMode$.next({
      status: !this.isEditMode$.value.status,
      loading: loading !== undefined ? loading : this.isEditMode$.value.loading
    });
  };
}
